import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import { tourSteps } from './tourSteps';

const TourProvider = () => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    // sessionStorage.setItem('tourCompleted', 'false');

   
    const tourCompleted = sessionStorage.getItem('tourCompleted');
    console.log('tourCompleted ',tourCompleted);
    if (!tourCompleted) {
      setRun(true); // start immediately
    }
  }, []);

  const handleTourCallback = (data) => {
    const { status } = data;
    const finishedStatuses = ['finished', 'skipped'];

    if (finishedStatuses.includes(status)) {
        sessionStorage.setItem('tourCompleted', 'true');
      setRun(false);
    }
  };

  return (
    <Joyride
      steps={tourSteps}
      run={run}
      continuous
      scrollToFirstStep
      showProgress
      showSkipButton
      callback={handleTourCallback}
      styles={{ options: { zIndex: 10000 } }}
    />
  );
};

export default TourProvider;
